export interface IInvoiceTransplants {
      id: number,
      centerId: number,
      centerAlias: string,
      organType: number,
      invoiceNumber: number,
      lastUpdated: string,
      invoiceDate: string,
      invoiceSent: string,
      protectedReportEndDate: string,
      received: string,
      transplants: number,
      transplantsFacilitatedK: number,
      transplantsNonFacilitatedK: number,
      transplantsFacilitatedL: number,
      transplantsNonFacilitatedL: number,
      invoiceAmount: number,
      isBillableKidney: boolean,
      isBillableLiver: boolean,
      missingFees: boolean,
      missingContact: boolean,
      isSelected: boolean
}
